import { render } from "./TabList.vue?vue&type=template&id=593ddf6a&scoped=true"
import script from "./TabList.vue?vue&type=script&lang=js"
export * from "./TabList.vue?vue&type=script&lang=js"

import "./TabList.vue?vue&type=style&index=0&id=593ddf6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593ddf6a"]])

export default __exports__